import { Head } from "vike-react/Head";
import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GoogleAnalytics = () => {
  useEffect(() => {
    // Helper to update GA consent based on local preferences
    const getStoredConsent = () => {
      try {
        const consent = localStorage.getItem("cookie-consent");
        return consent ? JSON.parse(consent) : null;
      } catch {
        return null;
      }
    };

    const loadGTM = () => {
      // 1. Initialize dataLayer and gtag if not already present
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function gtag(){window.dataLayer.push(arguments);};

      // 2. Check for existing consent and update GA immediately before loading the script
      const savedPrefs = getStoredConsent();
      if (savedPrefs) {
        window.gtag('consent', 'update', {
          ad_storage: savedPrefs.advertising ? 'granted' : 'denied',
          ad_user_data: savedPrefs.advertising ? 'granted' : 'denied',
          ad_personalization: savedPrefs.advertising ? 'granted' : 'denied',
          analytics_storage: savedPrefs.analytics ? 'granted' : 'denied'
        });
      }

      // 3. Load the actual GTM script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-RTFX58NN27';
      document.head.appendChild(script);

      window.gtag('js', new Date());
      window.gtag('config', 'G-RTFX58NN27', {
        anonymize_ip: true
      });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadGTM, { timeout: 3000 });
    } else {
      window.addEventListener('load', loadGTM);
    }
  }, []);

  return (
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Default Consent State (Server-side/Initial) */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent', 'default', {
              ad_storage: 'denied',
              ad_user_data: 'denied',
              ad_personalization: 'denied',
              analytics_storage: 'denied',
              wait_for_update: 500
            });
          `,
        }}
      />

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://www.googletagmanager.com" />

      <link
        rel="preload"
        as="style"
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap"
        rel="stylesheet"
        media="print"
        // @ts-ignore
        onLoad="this.media='all'"
      />
    </Head>
  );
};

export default GoogleAnalytics;
